/**
 * Transforms local island coordinates to global coordinates
 * @param localX Local X position relative to island center
 * @param localZ Local Z position relative to island center
 * @param islandCenterX Island center X in global coordinates
 * @param islandCenterZ Island center Z in global coordinates
 * @param islandRotationDegrees Island rotation in degrees
 */
export const transformToGlobal = (
	localX: number,
	localZ: number,
	islandCenterX: number,
	islandCenterZ: number,
	islandRotationDegrees: number
): { x: number; z: number } => {
	const radians = (islandRotationDegrees * Math.PI) / 180;
	const cos = Math.cos(radians);
	const sin = Math.sin(radians);

	const globalX = localX * cos - localZ * sin + islandCenterX;
	const globalZ = localX * sin + localZ * cos + islandCenterZ;

	return { x: globalX, z: globalZ };
};
